
<div class="category-btns">
  <span
    *ngFor="let areaCategory of areaCategories"
    class="button button-simple"
    [ngClass]="areaCategory === selectedAreaCategory ? 'active' : ''"
    [innerHTML]="areaCategory"
    (click)="selectAreaCategory(areaCategory)"
  ></span>
</div>